module.exports = __webpack_public_path__ + "static/media/uploaded-file-icon.33039ae5.svg";